import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { CompanySettingsService } from 'src/app/services/company-settings.service';
import { AppConfigService } from 'src/app/app-config.service.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TaskService } from 'src/app/services/task.service';
import CustomStore from 'devextreme/data/custom_store';
import { ToastService } from 'ng-uikit-pro-standard';
import {DatePipe, Location} from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import * as moment from 'moment';

@Component({
  selector: 'app-create-update-task',
  templateUrl: './create-update-task.component.html',
  styleUrls: ['./create-update-task.component.scss']
})
export class CreateUpdateTaskComponent implements OnInit {

  _formNewTask: FormGroup = new FormGroup({
    taskid: new FormControl({ value: 0, disabled: false }, []),
    name: new FormControl({ value: '', disabled: false }, []),
    projectid: new FormControl({ value: '', disabled: false }, [Validators.required]),
    employeeid: new FormControl({ value: '', disabled: false }, []), // !!
    taskresources : new FormControl({ value: '', disabled: false }, []),
    statusid: new FormControl({ value: 0, disabled: false }, []),
    todocategoryid: new FormControl({ value: 0, disabled: false }, []),
    priorityid: new FormControl({ value: 0, disabled: false }, []),
    area: new FormControl({ value: '', disabled: false }, []),
    phaseid: new FormControl({ value: 0, disabled: false }, []),
    estimatedcost: new FormControl({ value: 0, disabled: false }, []),
    startdate: new FormControl({ value: new Date(), disabled: false }, []),
    estimatedtime: new FormControl({ value: 0, disabled: false }, [Validators.pattern('[0-500][0-9]:[0-9][0-9]')]),
    duedate: new FormControl({ value: new Date(), disabled: false }, []),
    completionperc: new FormControl({ value: 0, disabled: false }, []),
    completiondate: new FormControl({ value: '', disabled: false }, []),
    notes: new FormControl({ value: '', disabled: false }, []),
    sort: new FormControl({ value: 0, disabled: false }, []),
    locationid: new FormControl({ value: 0, disabled: false }, []),
    vendorid: new FormControl({ value: 0, disabled: false }, []),
    summarytaskid: new FormControl({ value: 0, disabled: false }, []),
    user: new FormControl({ value: '', disabled: false }, []),
    projectaddress: new FormControl({ value: '', disabled: false }, []),
    projectname: new FormControl({ value: '', disabled: false }, []),
    createon: new FormControl({ value: new Date(), disabled: false }, []),
    resources : new FormControl('', []),
  });

  milestone: boolean;
  categorySelect: any;
  statusSelect: any;
  prioritySelect: any;
  employeeSelect: any;
  phasesSelect: any;
  locationSelect: any;
  projectslist: CustomStore;
  @Input() popupTask = false;

  now = new Date();
  //
  dateValue: number;
  todayButton: any;
  prevDateButton: any;
  nextDateButton: any;
  millisecondsInDay = 24 * 60 * 60 * 1000;
  today = new Date().getTime();
  resources: any;

  //Inputs Fecha
  startDate = { todayButton: {}, prevDateButton: {}, nextDateButton: {}, showDate: null };
  dueDate = { todayButton: {}, prevDateButton: {}, nextDateButton: {}, showDate: this.today };
  completionDate = { todayButton: {}, prevDateButton: {}, nextDateButton: {}, showDate: null };

  @Input() hideButtons = false;
  // @Input() project = {
  //   projectid: 0,
  //   projectname: '',
  //   projectnumber: ''
  // };
  private _project: any;
  @Input('project')
  set project(project: any) {
    this._project = project;
    if (project && project.projectid > 0) {
      this.isprojectview = true;
      this.setProjectInfo(project);

    }
    // this.setProjectInfo(project);
  }

  get project(): any { return this._project; }


  @Output() onsubmit = new EventEmitter<any>();
  @Output() onresources = new EventEmitter<any>();
  @Output() closemodal = new EventEmitter<any>();
  @Output() ocultarSave = new EventEmitter<any>();

  isprojectview = false;

  private _task: any;
  summarytaskSelect: any = [];
  subcontractors = [];

  @Input('task')
  set task(task: any) {
    this._task = task;
    if (task.ID > 0) {
      this.getTaskById();
      this.taskService.GetTaskEmployees().subscribe(result => {
        this.employeeSelect = result;
        this.setForm(task);
      });
    }
  }
  lastLocation: any;
  dateFormat: any;
  moneyFormat: any;
  disableInputs = false;
  get task(): any { return this._task; }

  primeraVez: boolean = false;

  disableDate: boolean = true;

  defaultPhase: any = 0;

  editLinkButton: any;
  externalLink: any;

  constructor(
    private router: Router,
    private datepipe: DatePipe,
    private toast: ToastService,
    private taskService: TaskService,
    private appconfig: AppConfigService,
    private activatedRoute: ActivatedRoute,
    public location:Location,
    public settingsCompany: CompanySettingsService,
    ) {
    this.taskService.GetTaskEmployees().subscribe(result => {
      this.employeeSelect = result
    });

    this.inputsDate(this.startDate, null);
    this.inputsDate(this.dueDate, null);
    this.inputsDate(this.completionDate, null); 
    this.dateFormat = this.appconfig.dateFormat + ' HH:mm';
    this.moneyFormat = this.appconfig.moneyFormat;

    this.editLinkButton = {
      icon: 'fa fa-link',
      type: 'default',
      onClick: () => {
        this.externalLink = this.externalLink.trim();
        if(this.externalLink!=='' && this.externalLink!==undefined){
          window.open(this.externalLink, "_blank");
        }
      },
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.project!==undefined && changes.project.previousValue!==undefined){
      this._project= changes.project.currentValue;
      this.ngOnInit();
    }
  }

  inputsDate(date, showdate) {
    if(showdate!==null){
      let year = this.datepipe.transform(showdate, 'yyyy');
      date.showDate =  parseInt(year)<1990 ? new Date().getTime() : new Date(showdate).getTime() ;
    }else{ date.showDate = showdate; }

    date.todayButton = {
      text: "Today",
      onClick: () => {
        date.showDate =  new Date().getTime();
      }
    };

    date.prevDateButton = {
      icon: "spinprev",
      stylingMode: "text",
      onClick: () => {
        date.showDate = date.showDate == null? this.today-this.millisecondsInDay : date.showDate -= this.millisecondsInDay;
      }
    };

    date.nextDateButton = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        date.showDate = date.showDate == null? this.today+this.millisecondsInDay : date.showDate += this.millisecondsInDay;
      }
    };
  }

  getTaskById() {
    // this.taskService.GetTaskById(this._task.ID).subscribe(result => {
    //   //console.log('Task Found', result);
    // })
  }

  limpiarmodalTask() {
    this.popupTask = false;
    this.closemodal.emit();
    this.initForm();
    this.ngOnInit();
    this._formNewTask.get('projectaddress').setValue(this.project.ADDRESS)
    this._formNewTask.get('projectname').setValue(this.project.NAME);
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.lastLocation = params['tab'];
    })
    
    this.taskService.GetTaskCategories().subscribe(result => {
      this.categorySelect = result;
      let id = result.find(x => x.DEFAULT == true).ID;
      if (!this._formNewTask.get('todocategoryid').value || this._formNewTask.get('todocategoryid').value == 0)
        this._formNewTask.get('todocategoryid').setValue(id);
    });
    
    this.taskService.GetTaskStatus().subscribe(result => {
      this.statusSelect = result;
      let id = result.find(x => x.DEFAULT == true).ID;
      if (!this._formNewTask.get('statusid').value || this._formNewTask.get('statusid').value == 0)
        this._formNewTask.get('statusid').setValue(id);
    });

    this.taskService.GetTaskPriorities().subscribe(result => {
      this.prioritySelect = result;
      let id = result.find(x => x.DEFAULT == true).ID;
      if (!this._formNewTask.get('priorityid').value || this._formNewTask.get('priorityid').value == 0)
        this._formNewTask.get('priorityid').setValue(id);
    });

    this.taskService.GetTaskPhases().subscribe(result => {
      this.phasesSelect = result;
      let id = result.find(x => x.DEFAULT == true).ID;
      this.settingsCompany.GetClientSettings("ProjectEstimatingPhase").subscribe(data=>{
        let defaultPhase = Number(data[0].VALUE);
        if(defaultPhase){
          this._formNewTask.get('phaseid').setValue(defaultPhase);
        }else if (!this._formNewTask.get('phaseid').value || this._formNewTask.get('phaseid').value == 0){
          this._formNewTask.get('phaseid').setValue(id);
        }
      })
    }); 

    this.taskService.GetTaskLocation().subscribe(result => {
      this.locationSelect = result;
      let id = result.find(x => x.DEFAULT == true).ID;
      if (!this._formNewTask.get('locationid').value || this._formNewTask.get('locationid').value == 0)
        this._formNewTask.get('locationid').setValue(id);
    });

    if (this.project && this.project.projectid > 0) {
      this.setProjectInfo(this.project);
      this.isprojectview = true;
    }

    let mythis = this;
    this.projectslist = new CustomStore({
      key: "ID",
      load: function (loadOptions: any) {
        return mythis.taskService.GetProjectByName(loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });
    
  }

  getSubContractors() {
    if(this.subcontractors.length==0){
      this.taskService.GetSubContractors(this.project.projectid).subscribe(result => {
        this.subcontractors = result;
      })
    }
    
  }
  getSummaryTask() {
    this.taskService.GetSummaryTask(this.project.projectid).subscribe(result => {
      this.summarytaskSelect = result;
    })
  }
  // range slider
  format(value) {
    return value + "%";
  }

  initForm(item?: any) {
    this._formNewTask = new FormGroup({
      taskid: new FormControl({ value: 0, disabled: false }, []),
      name: new FormControl({ value: '', disabled: false }, []),
      projectid: new FormControl({ value: '', disabled: false }, [Validators.required]),
      employeeid: new FormControl({ value: '', disabled: false }, []), // !!
      taskresources : new FormControl({ value: '', disabled: false }, []),
      statusid: new FormControl({ value: 0, disabled: false }, []),
      todocategoryid: new FormControl({ value: 0, disabled: false }, []),
      priorityid: new FormControl({ value: 0, disabled: false }, []),
      area: new FormControl({ value: '', disabled: false }, []),
      phaseid: new FormControl({ value: 0, disabled: false }, []),
      estimatedcost: new FormControl({ value: 0, disabled: false }, []),
      startdate: new FormControl({ value: new Date(), disabled: false }, []),
      estimatedtime: new FormControl({ value: 0, disabled: false }, [Validators.pattern('[0-9][0-9]:[0-9][0-9]')]),
      duedate: new FormControl({ value: new Date(), disabled: false }, []),
      completionperc: new FormControl({ value: 0, disabled: false }, []),
      completiondate: new FormControl({ value: '', disabled: false }, []),
      notes: new FormControl({ value: '', disabled: false }, []),
      sort: new FormControl({ value: 0, disabled: false }, []),
      locationid: new FormControl({ value: 0, disabled: false }, []),
      vendorid: new FormControl({ value: 0, disabled: false }, []),
      summarytaskid : new FormControl({ value: 0, disabled: false }, []),
      user: new FormControl({ value: localStorage.getItem('username'), disabled: false }, []),
      // userid: new FormControl({ value: localStorage.getItem('customerid'), disabled: false }, []),
      createon: new FormControl({ value: new Date(), disabled: false }, []),
      projectaddress: new FormControl({ value: '', disabled: false }, []),
      projectname: new FormControl({ value: '', disabled: false }, []),
      // resourceArray: new FormControl('', []),
    });
    
    this.changeDueDate(true);
    this.getSummaryTask();
  }

  rebootForm(){
    this._formNewTask = new FormGroup({
      taskid: new FormControl({ value: 0, disabled: false }, []),
      name: new FormControl({ value: '', disabled: false }, []),
      projectid: new FormControl({ value: '', disabled: false }, [Validators.required]),
      employeeid: new FormControl({ value: '', disabled: false }, []), // !!
      taskresources : new FormControl({ value: '', disabled: false }, []),
      statusid: new FormControl({ value: 0, disabled: false }, []),
      todocategoryid: new FormControl({ value: 0, disabled: false }, []),
      priorityid: new FormControl({ value: 0, disabled: false }, []),
      area: new FormControl({ value: '', disabled: false }, []),
      phaseid: new FormControl({ value: 0, disabled: false }, []),
      estimatedcost: new FormControl({ value: 0, disabled: false }, []),
      startdate: new FormControl({ value: new Date(), disabled: false }, []),
      estimatedtime: new FormControl({ value: 0, disabled: false }, [Validators.pattern('[0-9][0-9]:[0-9][0-9]')]),
      duedate: new FormControl({ value: new Date(), disabled: false }, []),
      completionperc: new FormControl({ value: 0, disabled: false }, []),
      completiondate: new FormControl({ value: '', disabled: false }, []),
      notes: new FormControl({ value: '', disabled: false }, []),
      sort: new FormControl({ value: 0, disabled: false }, []),
      locationid: new FormControl({ value: 0, disabled: false }, []),
      vendorid: new FormControl({ value: 0, disabled: false }, []),
      summarytaskid : new FormControl({ value: 0, disabled: false }, []),
      user: new FormControl({ value: localStorage.getItem('username'), disabled: false }, []),
      // userid: new FormControl({ value: localStorage.getItem('customerid'), disabled: false }, []),
      createon: new FormControl({ value: new Date(), disabled: false }, []),
      projectaddress: new FormControl({ value: '', disabled: false }, []),
      projectname: new FormControl({ value: '', disabled: false }, []),
      // resourceArray: new FormControl('', []),
    });
  }
 
  setForm(item?: any) {
    this.isprojectview = true;
    this.disableInputs = item.STATUSID == 3;
    this.resources = item.resourcesIDs ? item.resourcesIDs.split(',').map(x => +x) : [];
    
    if (this.disableInputs)
      this.ocultarSave.emit();
 
    if (!this.project )
      this.project = {};
    this.project.projectid = item.PROJECTID;
    this.project.projectname = item.PROJECTNAME;
    this.summarytaskSelect = this.summarytaskSelect.filter(x => x.PROJECTID == item.PROJECTID);
    this.inputsDate(this.startDate, item.StartDate);
    this.inputsDate(this.dueDate, item.DUEDATE);
    (item.COMPLETIONPERC*100) == 100 ? item.COMPDATE : item.COMPDATE = null;
    this.inputsDate(this.completionDate, item.COMPDATE);
    // item.duration = item.duration ? '00.'+item.duration : '00.00';
    
    let durat = item.duration ? item.duration.toString().split('.') : ['', ''];

    if(durat[1]!==undefined && durat[1]!==null){
      
      let hours, minutes;
      let hours_initial = durat[0].substr(0, 1);
      
      if(hours_initial==0){
        hours = durat[0].substr(1, 2);
        minutes = durat[1].substr(2, 2);
      }else{
        hours = durat[0].substr(0, 3);
        hours.length == 2 ? hours = '0'+hours : '';
        minutes = durat[1].substr(0, 2);
        minutes.length == 1 ? minutes = minutes+'0' : '';
      }
      item.duration = hours+minutes;
    }else{
      // item.duration = item.duration+'00';
      item.duration.toString().length == 3 ? item.duration = item.duration+'00' : '';
      item.duration.toString().length == 2 ? item.duration = '0'+item.duration+'00' : '';
      item.duration.toString().length == 1 ? item.duration = '00'+item.duration+'00' : '';
    }
    
    // item.REPONSIBLEID = null
    item.MILESTONEID == null || item.MILESTONEID == false ? this.milestone = false : this.milestone = true;
    this._formNewTask = new FormGroup({
      taskid: new FormControl({ value: item.ID, disabled: false }, []),
      name: new FormControl({ value: item.TASKNAME, disabled: false }, []),
      projectid: new FormControl({ value: item.PROJECTID, disabled: false }, [Validators.required]),
      employeeid: new FormControl({ value: item.REPONSIBLEID == undefined ? 0:item.REPONSIBLEID, disabled: false }, []),
      taskresources: new FormControl({ value: item.resourcesIDs ? item.resourcesIDs.split(',') : [], disabled: false }, []),
      statusid: new FormControl({ value: item.STATUSID, disabled: false }, []),
      todocategoryid: new FormControl({ value: item.TODOCATEGORYID, disabled: false }, []),
      priorityid: new FormControl({ value: item.PRIORITYID, disabled: false }, []),
      area: new FormControl({ value: item.area, disabled: false }, []),
      phaseid: new FormControl({ value: item.PHASEID, disabled: false }, []),
      estimatedcost: new FormControl({ value: item.estimatecost, disabled: false }, []),
      startdate: new FormControl({ value: this.startDate.showDate, disabled: false }, []),
      estimatedtime: new FormControl({ value: item.duration, disabled: false }, [Validators.pattern('[0-500][0-9]:[0-9][0-9]')]),
      duedate: new FormControl({ value: this.dueDate.showDate, disabled: false }, []),
      completionperc: new FormControl({ value: (item.COMPLETIONPERC*100), disabled: false }, []),
      completiondate: new FormControl({ value: this.completionDate.showDate, disabled: false }, []),
      notes: new FormControl({ value: item.notes, disabled: false }, []),
      sort: new FormControl({ value: item.order, disabled: false }, []),
      locationid: new FormControl({ value: item.LOCATIONID, disabled: false }, []),
      vendorid: new FormControl({ value: item.VENDORID, disabled: false }, []),
      summarytaskid: new FormControl({ value: item.SUMMARYTASKID, disabled: false }, []),
      user: new FormControl({ value: item.createdbyname, disabled: false }, []),
      resources : new FormControl('', []),
      projectaddress: new FormControl({ value: item.projectaddress, disabled: false }, []),
      projectname: new FormControl({ value: item.PROJECTNAME, disabled: false }, []),
      createon: new FormControl({ value: item.WORKDATE, disabled: false }, []),
    });

    this.getSummaryTask();
    this.getSubContractors();
    
    this.onResourcesChange(item.resourcesIDs ? item.resourcesIDs.split(',').map(Number) : []);
  }

  onResourcesChange(ev) {
    if (ev && this.employeeSelect) {
      let contacts = this.employeeSelect.filter(x => ev.includes(x.ID));
      this.onresources.emit(contacts);
    }
  }
  onStatusChange(ev) {
    if (ev.value == 3) {
      if (this._formNewTask.get('completionperc').value < 100) {
        this.toast.warning('% Completed has to be 100');
      }
      if (!this._formNewTask.get('completiondate').value) {
        this.toast.warning('Please enter completion date');
      }
    }
  }

  validateForm() {
    let hasError = false;
    let value = this._formNewTask.value;
    // if (this._formNewTask.gets('name').hasError('required')) {
    //   this.toast.warning('Please enter task name');
    //   hasError = true
    // }
    // if (this._formNewTask.get('locationid').hasError('required')) {
    //   this.toast.warning('Please enter location');
    //   hasError = true
    // }
    // if (this._formNewTask.get('phaseid').hasError('required')) {
    //   this.toast.warning('Please enter phase');
    //   hasError = true
    // }
    if (!value.projectid) {
      this.toast.warning('Please enter project');
      hasError = true
    }
    // if (!value.vendorid) {
    //   this.toast.warning('Please enter subcontractor');
    //   hasError = true
    // }

    if (value.statusid == 3) {
      if (value.completionperc < 100) {
        this.toast.warning('% Completed has to be 100');
        hasError = true
      }
      if (!value.completiondate) {
        this.toast.warning('Please enter completion date');
        hasError = true
      }
    }

    return hasError;
  }

  setProjectInfo(item) {
    if (item) {
      this._formNewTask.get('projectid').setValue(item.projectid);
      // this._formNewTask.get('projectaddress').setValue('');
      // this._formNewTask.get('projectname').setValue(item.projectname, { disabled: true });
    }

    this.getSubContractors();
    this.getSummaryTask();
    // projectid: new FormControl({ value: item.PROJECTID, disabled: false }, [Validators.required]),
    // projectaddress: new FormControl({ value: item.projectaddress, disabled: false }, []),
    // projectname: new FormControl({ value: item.PROJECTNAME, disabled: false }, []),

  }

  updateTask(visibleModal = false, goedit = false, volver = false) {
 
    if (this.validateForm())
      return;

    
    // console.log('Form ', this._formNewTask.value);
    let values = this._formNewTask.value;

    if (!values.name) {
      values.name = 'New Task';
      return
    }
    // values.duration = values.estimatedtime ? '00.'+values.estimatedtime : '00.00';
    // let durat = values.duration ? values.duration.toString().split('.') : ['', ''];
    // let duration = [];
    // console.log(values.estimatedtime);
    if(typeof values.estimatedtime== 'string' && values.estimatedtime!==''){
      let hours, minutes;
      let hours_initial = values.estimatedtime.substr(0, 1);
      if(hours_initial==0){
        hours = values.estimatedtime.substr(1, 2);
        minutes = values.estimatedtime.substr(3, 2);
        // console.log(hours+'/'+minutes);
      }else{
        hours = values.estimatedtime.substr(0, 3);
        minutes = values.estimatedtime.substr(3, 2);
      }
      values.estimatedtime = hours+'.'+minutes;
    }
    // values.estimatedtime = '10.00';
    // console.log('Duration ',values.estimatedtime);

    values.completionperc = values.completionperc/100;
    values.locationid = values.locationid ? values.locationid : 0;
    values.phaseid = values.phaseid ? values.phaseid : 0;
    values.vendorid = values.vendorid ? values.vendorid : 0;
    values.estimatedcost = values.estimatedcost ? values.estimatedcost : 0;
    values.summarytaskid = values.summarytaskid  ? values.summarytaskid  : 0;
    values.completiondate = this.datepipe.transform(values.completiondate, 'yyyyMMdd hh:mm:ss');
    values.createon = values.createon ? new Date(values.createon) : '';
    values.startdate = this.datepipe.transform(values.startdate, 'yyyyMMdd hh:mm:ss');
    values.duedate = this.datepipe.transform(values.duedate, 'yyyyMMdd hh:mm:ss');
    values.sort = values.sort == null || values.sort == '' ? 0 : values.sort;
    this._formNewTask.get('sort').setValue(values.sort);
    values.resources = (values.taskresources && values.taskresources.length > 0) ? values.taskresources.join(',') : '0';
    
    
    // values.startdate = this.pipeDate.transform(values.startdate, 'dd-MM-yyy hh:mm:ss');
    // values.duedate = this.pipeDate.transform(values.duedate, 'dd-MM-yyy hh:mm:ss');
    values.method = 'Insert_Task_ce'; 
    // console.log('Envio ',values);
    this.taskService.updateTask2(values).subscribe(result => {
      let id = result[0].Column1;
      this.toast.success('Task Updated Successfully');
      this.onsubmit.emit(visibleModal);
      this.initForm();
      if (this.lastLocation !== 'Task') {
        this.ngOnInit();
        if (goedit) {
          this.router.navigateByUrl(`/taskManagement/editTask?numID=${id}&numTODOID=${id}`)
          this.onsubmit.emit(false);
          return;  
        }
        // this.onsubmit.emit();
      }
      this.onResourcesChange(values.resources);
      // console.log(this.lastLocation)
      // console.log(volver)
      if(volver){
        if(this.lastLocation=='Task'){
          this.router.navigate(['editProject'], { queryParams: { numID: this.project.projectid, tab: 'Task'}});
        }else if (this.lastLocation=='TaskManagement'){
          this.router.navigate(['taskManagement'], { queryParams: { tab: 'Task List'} });
        }else if (this.lastLocation=='Gantt View'){
          this.router.navigate(['taskManagement'], { queryParams: { tab: 'Gantt View'} });
        }else{
          this.location.back();
        }
      }
    })
  }

  updateProjectInfo(item) {
    if (item.selectedItem.ID) {
      this._formNewTask.get('projectid').setValue(item.selectedItem.ID);
      // this.state = item.selectedItem.First + ' ' + item.selectedItem.Last;
    }
    this.getSubContractors();
  }

  changeDueDate(entrando?){
      let duration = this._formNewTask.get('estimatedtime').value;
      duration== null || duration == '' ? duration = '00000' : '';
      let startDate = new Date(this._formNewTask.get('startdate').value);
      let resources = 0
      if (this.resources != undefined){
        resources = this.resources.length;
      } 
      let porcentaje = this._formNewTask.get('completionperc').value;
      porcentaje == 0 ? porcentaje = 1 : porcentaje;
      // if(porcentaje==0){ porcentaje = 1; }else if(porcentaje==100){ this.disableDate = false;}
      resources == 0 ? resources = 1 : resources;
      
      let hours;
      let minutes;
      
      let hours_initial = duration.toString().substr(0, 1);
      if(hours_initial==0){
        hours = duration.toString().substr(1, 2);
        minutes = duration.toString().substr(3, 2);
      }else{
        hours = duration.toString().substr(0, 3);
        minutes = duration.toString().substr(3, 2);
      }
      
      let durationFinal = hours+'.'+minutes;
     
      
      if(minutes>59){ 
        let finalHour = Number(minutes)/60;
        let finalMinutes = Number(minutes)%60;
        finalHour = Math.round(finalHour) + Number(hours);
        let estimatedtime;

        let legnth_hour = finalHour.toString().length;
        if(legnth_hour==1){
          estimatedtime = '00'+finalHour+finalMinutes;
        }else if(legnth_hour==2){
          estimatedtime = '0'+finalHour+finalMinutes;
        }else{
          estimatedtime = finalHour+''+finalMinutes;
        }
        estimatedtime.toString().length == 3 ? estimatedtime = estimatedtime+'0' : '';

        this._formNewTask.get('estimatedtime').setValue(estimatedtime);
      }else{
        console.log('Duration Final ', durationFinal);
        // console.log('((',Number(durationFinal),' / ',8,') /', resources,') *', porcentaje);
        // let estimatedTime = ((Number(durationFinal) / 8) / resources) * Number(porcentaje);
        // console.log('((',Number(durationFinal),' / ',8,') /', resources,')');
        let estimatedTime = ((Number(durationFinal) / 8) / resources);
          console.log('Estimated Time ',estimatedTime);
          // console.log('Suma ', moment(startDate).add(estimatedTime))

        let finalDueDate: any = new Date(startDate.setDate(startDate.getDate() + estimatedTime));

        let finalDate = moment(startDate, 'MM-DD-YYYY').add(estimatedTime, 'days').format('DD-MM-YYYY hh:mm');
        console.log('Final Date con Moment: ',finalDate)

        // finalDueDate = this.datepipe.transform(finalDueDate,this.dateFormat);
        console.log(finalDueDate);
        this._formNewTask.get('duedate').setValue(finalDueDate);
        this.primeraVez=true;
      }

      // console.log(this._formNewTask.value)
  }

  enableCompletionDate(){
    let porcentaje = this._formNewTask.get('completionperc').value;
    porcentaje==100? this.disableDate = false : this.disableDate = true;
  }
}
